import React, { useRef, useState, useEffect } from 'react';

const EULAViewer = ({ pdfUrl, onAgree }) => {
  const scrollContainerRef = useRef(null);
  const [agreed, setAgreed] = useState(false);
  const [canAgree, setCanAgree] = useState(false);

  useEffect(() => {
    const el = scrollContainerRef.current;
    if (!el) return;

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = el;
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        console.log('Scrolled to bottom');
        setCanAgree(true);
      }
    };

    el.addEventListener('scroll', handleScroll);
    return () => el.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="max-w-3xl mx-auto p-4">
      <h2 className="text-xl font-semibold mb-2 text-white">End User License Agreement</h2>
      <div
        ref={scrollContainerRef}
        className="border rounded-md overflow-y-scroll"
        style={{ height: '500px' }}
      >
        <iframe
          src={pdfUrl}
          title="EULA PDF"
          width="100%"
          height="1000px"
          style={{ border: 'none' }}
        />
      </div>


      <div className="mt-4 flex items-center space-x-2 text-white">
        <input
          type="checkbox"
          disabled={!canAgree}
          checked={agreed}
          onChange={(e) => {
            setAgreed(e.target.checked);
            if (e.target.checked && onAgree) onAgree();
          }}
        />
        <label>I have read and agree to the terms of the EULA</label>
      </div>
    </div>
  );
};

export default EULAViewer;
